import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { mapCursor, mapPopup } from "../../../Utils/MapTools";
import { DangerAlert, loadingSc, SuccessAlert, WarningAlert } from "../../Layout/AlertDiv";
import { failed, success } from "../../../Utils/Alerts";
import { MyMap } from "../../Map/View/MyMap";
import { addSingleFeatureTotempLayerByXY, tempLayer } from "../../Map/Layers/TempLayer";
import { setMapMode } from "../../../Redux/Slices/mapSlice";
import axios from "axios";
import { _serverUrl2 } from "../../../config";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { Confirm } from "notiflix";
import TaskLog from "./TaskLog";
import TaskImageLog from "./TaskImageLog";

export default function TasksUpdate() {
  const history = useHistory();
  const taskID = useParams().id;

  const getUserInfo = useSelector((state) => state.getUserInfo);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [info, setInfo] = useState([]);

  const onSubmitForm = async () => {
    if (selectedLocation == null) {
      failed("Görevi Kaydetmek İçin Konum Bilgisi Seçilmiş Olmalıdır.");
      return;
    }

    let postJSON = {
      id: taskID,
      maks_kn: null,
      username: getUserInfo.Id,
      gorev_aciklama: document.getElementById("gorevAciklamasi").value,
      gorev_durum: document.getElementById("gorevDurumu").value,
      gorev_kayit_tarihi: new Date(),
      geometry: {
        geom: "POINT(" + selectedLocation.x + " " + selectedLocation.y + ")",
        tip: selectedLocation.tip,
        maks_kn: selectedLocation.maks_kn,
      },
    };

    axios
      .post(_serverUrl2 + "/task/addUpdate", postJSON)
      .then((res) => {
        if (res.data.status) {
          success("Görev Kaydedildi.");
          history.push("/dashboard/task");
        } else {
          failed("Görev Kaydedilirken Hata Oluştu [" + res.data.error + "]");
        }
      })
      .catch((error) => {
        failed("Görev Kaydedilirken Hata Oluştu [" + error + "]");
      });
  };

  const onClickMapEvent = async (e) => {
    mapPopup.hide();
    addSingleFeatureTotempLayerByXY(e.coordinate[0], e.coordinate[1]);
    setSelectedLocation({
      x: e.coordinate[0],
      y: e.coordinate[1],
      tip: "KONUM",
      maks_kn: null,
    });
    document.getElementById("gorevTipi").value = "KONUM";
    return;
  };

  const onClickRemoveTask = async () => {
    let json = {
      kullanici: getUserInfo.Id,
      id: taskID,
    };
    Confirm.show("Emin misiniz", "Görevi Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", () => {
      axios
        .post(_serverUrl2 + "/task/remove", json)
        .then((res) => {
          if (res.data.status) {
            success("İşlem Başarılı");
            history.push("/dashboard/task");
          } else {
            failed("Silme işlemi sırasında hata oluştu." + res.data.error);
          }
        })
        .catch((err) => {
          failed("Silme işlemi sırasında hata oluştu." + err);
        });
    });
  };

  const getInfosFromNode = useCallback(async () => {
    loadingSc(true);
    await axios
      .get(_serverUrl2 + "/task/get/" + taskID)
      .then((res) => {
        if (res.data.status) {
          console.log(res.data);
          let v = res.data.rows[0];
          if (v.gorev_durum === "ISLEMDE") {
            setMapMode("Haritadan Görevin Konumuna Tıklayınız.");
            mapCursor("crosshair");
            MyMap.on("singleclick", onClickMapEvent);
          }
          setInfo(v);
          document.getElementById("gorevAciklamasi").value = v.gorev_aciklama;
          document.getElementById("sahaAciklamasi").value = v.saha_aciklama;
          document.getElementById("gorevTipi").value = v.tip;
          document.getElementById("gorevDurumu").value = v.gorev_durum;

          setSelectedLocation({
            x: v.x,
            y: v.y,
            tip: v.tip,
            maks_kn: v.maks_kn,
          });
          addSingleFeatureTotempLayerByXY(v.x, v.y);
        } else {
        }
      })
      .catch(() => {});

    await axios
      .get(_serverUrl2 + "/main/getImages/1/" + taskID)
      .then((res) => {
        if (res.data.status) {
          setImages(res.data.rows);
        } else {
          failed("Hata Oluştu!");
        }
      })
      .catch(() => {
        failed("Hata Oluştu!");
      });
    loadingSc(false);
  }, [taskID]);


  const gorevSonuclandir = async (bool) => {
    if (bool) {
      // ONAYLA
      await axios
        .post(_serverUrl2 + "/task/updateStatus", {
          gorev_kontrol_aciklama: document.getElementById("kontrolAciklama").value,
          gorev_durum: "ONAYLANDI",
          id: taskID,
          username: getUserInfo.Id,
        })
        .then((res) => {
          if (res.data.status) {
            success("Görev Onaylandı.");
            setModalVisible(false);
            history.push("/dashboard/task");
          } else {
            failed("Hata Oluştu.");
          }
        })
        .catch(() => {
          failed("Hata Oluştu.");
        });
    } else {
      // REDDET
      await axios
        .post(_serverUrl2 + "/task/updateStatus", {
          gorev_kontrol_aciklama: document.getElementById("kontrolAciklama").value,
          gorev_durum: "REDDEDİLDİ",
          id: taskID,
          username: getUserInfo.Id,
        })
        .then((res) => {
          if (res.data.status) {
            success("Görev Reddedildi.");
            setModalVisible(false);
            history.push("/dashboard/task");
          } else {
            failed("Hata Oluştu.");
          }
        })
        .catch(() => {
          failed("Hata Oluştu.");
        });
    }
  };

  useEffect(() => {
    MyMap.addLayer(tempLayer);
    MyMap.addOverlay(mapPopup);
    if (taskID == 0) {
      setMapMode("Haritadan Görevin Konumuna Tıklayınız.");
      mapCursor("crosshair");
      MyMap.on("singleclick", onClickMapEvent);
    } else {
      getInfosFromNode();
    }

    return () => {
      if (document.getElementById("map").style.cursor == "crosshair") {
        setMapMode(null);
        mapCursor("default");
        MyMap.un("singleclick", onClickMapEvent);
      }
      MyMap.removeLayer(tempLayer);
      mapPopup.hide();
      MyMap.removeOverlay(mapPopup);
      tempLayer.getSource().clear();
    };
  }, [taskID, getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">
            <b>{taskID == 0 ? "Yeni Görev Oluştur" : "Görevi Düzenle"}</b>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox" style={{ textAlign: "left" }}>
          <div className="row">
            <div className="col-sm-4">
              <label style={labelStyle}>Görev Tipi</label>
              <select disabled id="gorevTipi" style={{ borderLeft: "3px solid orange", fontSize: "13px" }} className="form-control form-select selectStyle">
                <option></option>
                <option>NUMARATAJ</option>
                <option>BİNA</option>
                <option>KONUM</option>
              </select>
            </div>
            <div className="col-sm-4">
              <label style={labelStyle}>Görev Durumu</label>
              <select disabled id="gorevDurumu" style={{ borderLeft: "3px solid orange", fontSize: "13px" }} className="form-control form-select selectStyle">
                <option>ISLEMDE</option>
                <option>YAPILDI</option>
                <option>ONAYLANDI</option>
                <option>REDDEDİLDİ</option>
              </select>
            </div>
            {taskID != 0 && (
              <div className="col-sm-4">
                <br />
                <TaskLog tip={1} id={taskID} />
                {info.gorev_durum == "ISLEMDE" && getUserInfo.Rol.includes("2") && (
                  <button className="redBtn" style={{ fontSize: "13px", width: "100px" }} onClick={() => onClickRemoveTask()}>
                    Görevi Sil
                  </button>
                )}
              </div>
            )}
            <div className="col-sm-12">
              <hr style={{ margin: "10px" }} />
            </div>
            <div className="col-sm-12">
              <label style={labelStyle}>Görev Konumu</label>
              {selectedLocation === null ? (
                <DangerAlert head={"Görevin Konumu Seçilmedi."} content={"Konumu belirlemek için haritada tıklama yapınız."} />
              ) : (
                <SuccessAlert
                  head={"Görevin Konumu Belirlendi"}
                  content={
                    `Saha çalışanlarının kontrolü için konum belirlendi.` +
                    (info.gorev_durum == "ISLEMDE" || taskID == 0 ? "Konumu değiştirmek için haritada tekrar tıklama yapabilirsiniz.." : "")
                  }
                />
              )}
            </div>
            <div className="col-sm-12">
              <label style={labelStyle}>Görev Açıklaması</label>
              <textarea id="gorevAciklamasi" style={{ fontSize: "13px", height: "75px" }} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-12" style={{ marginTop: "5px" }}>
              <label style={labelStyle}>Saha Açıklaması</label>
              <textarea disabled id="sahaAciklamasi" style={{ fontSize: "13px", height: "75px" }} className="form-control form-control-sm" />
            </div>
            <div className="col-sm-12" style={{ marginTop: "5px" }}>
              <label style={labelStyle}>Sahadan Çekilen Fotoğraflar</label>
              {images.length == 0 ? (
                <WarningAlert head={"Fotoğraf eklenmemiş."} content={"Görev için sahadan fotoğraf bilgisi eklenmemiş."} />
              ) : (
                <div className="d-flex" style={{ flexDirection: "row", padding: "5px", maxWidth: "100%", overflowX: "scroll" }}>
                  {images.map((d) => {
                    return (
                      <div className="d-flex" style={{ flexDirection: "column", position: "relative" }}>
                        <img
                          alt="Sahadan Çekilen Fotoğraf"
                          src={d.foto_path}
                          style={{ borderRadius: "17px", width: "130px", height: "130px", padding: "5px", cursor: "pointer" }}
                          onClick={() => setSelectedImage(d.foto_path)}
                        />
                        <div>
                          <TaskImageLog id={d.id} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="col-sm-12">
              <hr />
            </div>
            <div className="col-sm-4" style={{ marginTop: "5px" }}>
              <button style={{ fontSize: "12px" }} className="darkOrangeBtn" onClick={() => history.push("/dashboard/task")}>
                Geri Dön
              </button>
            </div>
            {info.gorev_durum !== "ISLEMDE" && taskID != 0 ? (
              <div className="col-sm-8" style={{ marginTop: "5px" }}>
                <button style={{ fontSize: "12px" }} className="blueBtn" onClick={() => setModalVisible(true)}>
                  Görevi Sonuçlandır
                </button>
              </div>
            ) : (
              <div className="col-sm-8" style={{ marginTop: "5px" }}>
                <button style={{ fontSize: "12px" }} className="greenBtn" onClick={() => onSubmitForm()}>
                  Görevi Kaydet
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {selectedImage !== null ? <Lightbox mainSrc={selectedImage} onCloseRequest={() => setSelectedImage(null)} /> : null}
      <Modal isOpen={modalVisible} contentLabel="Görevi Sonuçlandır" closeTimeoutMS={200} style={customStyles}>
        <div className="row">
          <div className="col-sm-12" style={{ marginBottom: "10px" }}>
            <label>Kontrol Açıklaması</label>
            <textarea id="kontrolAciklama" className="form-control form-control-sm" />
          </div>
          <div className="col-sm-3">
            <button className="darkOrangeBtn" onClick={() => setModalVisible(false)}>
              Geri
            </button>
          </div>
          <div className="col-sm-1">&nbsp;</div>
          <div className="col-sm-4">
            <button className="redBtn" onClick={() => gorevSonuclandir(false)}>
              Görevi Reddet
            </button>
          </div>
          <div className="col-sm-4">
            <button className="greenBtn" onClick={() => gorevSonuclandir(true)}>
              Görevi Onayla
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const labelStyle = {
  fontWeight: "bold",
  fontSize: "13px",
};
const customStyles = {
  content: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "551px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  overlay: {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(0, 0, 0, 0.10)",
  },
};
